<template>
<div class="AppHeader">
  <div class="AppHeader__logo">
    <icon-svg symbol="logo"/>
  </div>

  <div class="AppHeader__nav">
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link :to="{name:'dashboard'}">Dashboard</router-link> |
      <router-link to="/about">About</router-link> |
      <router-link to="/ui-kit">UI Kit</router-link> |
    </nav> -->

    <router-link :to="{name: 'dashboard'}">
      <icon-svg symbol="nav-home"/>
      <span>Home</span>
    </router-link>

    <router-link :to="{name: 'home'}">
      <icon-svg symbol="nav-risks"/>
      <span>Risks</span>
    </router-link>

    <router-link :to="{name: 'home'}">
      <icon-svg symbol="nav-suggestions"/>
      <span>Suggestions</span>
    </router-link>

  </div>

  <div class="AppHeader__user" v-if="!$store.getters.username">
    <span>Unauthorized</span>
  </div>
  <div class="AppHeader__user" v-else>
    <span>
      <router-link :to="{name: 'profile'}">{{$store.getters.username}}</router-link>
    </span>
    <i v-if="profile">
      <icon-svg v-if="!profile.image" symbol="avatar"/>
      <img v-else width="48" height="48" :src="profile.image" alt="."/>
    </i>
  </div>


</div>
</template>

<script>
import {mapState} from 'vuex';
import {UserState, UserProfile} from '@/store/user/types';
export default {
  name: 'AppHeader',
  components: {},
  computed: {
    ...mapState('user', {
      /** @type {(state: UserState) => UserProfile} user profile */
      profile: state => state.profile,
    }),
  },
  data() {
    return {
      // authOverlay: false,
    };
  },
  beforeMount() {
  },
  methods: {
    async fetchDashboard() {
    },
  },
}
</script>

<style lang="scss">
.AppHeader {
  padding: 2.25rem 4.5rem;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;

  &__logo {
    .icon {
      display: block;
      height: 64px;
      width: 131px;
    }
  }

  &__nav {
    flex: 1 1 auto;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-evenly;
    max-width: 780px;
    & > a {
      white-space: nowrap;
      .icon {
        width: 2rem;
        height: 2rem;
        vertical-align: middle;
        margin-right: 1em;
      }
      span {
        display: inline-block;
        vertical-align: middle;
        line-height: 2rem;
      }
      &.router-link-active {
        color: var(--masstrich-blue);
      }
    }
  }

  &__user {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    height: 48px;

    & > i {
      flex: 0 0 auto;
      height: 100%;
      width: 48px;
      border-radius: 50%;
      overflow: hidden;
      margin-left: 1.5rem;
      & > img,
      & > .icon {
        display: block;
        height: 100%;
        width: 100%;
      }
      & > img {
        object-fit: scale-down;
      }
      & > .icon {
        box-sizing: border-box;
        color: $accent-lighten;
        background: $accent;
        padding: 8%;
      }
    }

    & > span {
      flex: 0 0 auto;
      padding: .125em 0 0;
      line-height: 1;
      max-width: 8em;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: $masstrich-blue;
      &:hover {color: $accent}

      & > a {color: inherit}
    }
  }
}
</style>
